import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";

import MetaTags from 'react-meta-tags';
import Box from "@material-ui/core/Box";
import GeneralStyles from '../../styles/GeneralStyles';
import axios from 'axios';
// import { useCookies } from 'react-cookie';
// import cookieName from '../../helpers/cookiesDeclaration';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment';

const useGeneralStyles = GeneralStyles;

function TermsAndConditionsContent(props) {
    const classesG = useGeneralStyles();
    // const [newsContent, setNewsContent] = useState(null);
    const [termContent, setTermContent] = useState(null);
    // const [cookies, setCookie] = useCookies([cookieName]);
    const [loading, setLoading] = useState(false);
    const matchMobile = useMediaQuery('(max-width:600px)');

    const { url } = useParams();

    useEffect(() => {
        setLoading(true);
        if (url !== '' && url !== undefined && url !== null) {
            axios
                .get(
                    `${process.env.REACT_APP_GATEWAY_END_POINT}/terms-and-conditions-content/${url}`)
                .then((response) => {
                    setTermContent(response.data);
                    setLoading(false);
                })
                .catch((error) => {
                    setLoading(true);
                });
        } else {
            setLoading(false);
            const { history, location } = props;
            const { from } = location.state || {
                from: {
                    pathname: '/news',
                },
            };
            history.push(from);
        }
    }, [url, props]);

    const handleRedirectTerms = () => {
        const { history, location } = props;
        const { from } = location.state || {
            from: {
                pathname: `/terms&Conditions`,
            },
        };
        history.push(from);
    };

    const handleBackCategory = item => {
        const { history, location } = props;
        const { from } = location.state || {
            from: {
                pathname: `/terms&Conditions_categories/${item}`,
            },
        };
        history.push(from);
    };

    return (
        <React.Fragment>
            {loading && (
                <div className={classesG.divProgress}>
                    <CircularProgress size={68} className={classesG.progress} />
                </div>
            )}
            {!loading && (
                <React.Fragment>
                    {termContent === null || termContent === undefined ? '' : (
                        <React.Fragment>
                            <MetaTags>
                                <title>{termContent.Page_title}</title>
                                <meta name="description" content={termContent.Page_description} />
                            </MetaTags>

                            <div className={classesG.container}>
                                <section className={classesG.section}>
                                    <div className={classesG.workSecondSectionContent}>
                                        <div className={classesG.workSectionBox}>
                                            <div className={classesG.termsAndConditionsSectionTitle}>
                                                <h2>{termContent.Title}</h2>
                                                <div className={classesG.termsAndConditionsLink}>
                                                    <a onClick={() => handleBackCategory(termContent.Category.Url)} >
                                                        Back to {(termContent.Category.Title)}
                                                    </a>
                                                    <a onClick={() => handleRedirectTerms()} >
                                                        Back to Terms & Conditions
                                                    </a>
                                                </div>
                                                <Box component="span" m={4}></Box>
                                                <div dangerouslySetInnerHTML={{ __html: termContent.Text }} />
                                                <br />
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <Box mt={7}></Box>
                            </div>
                        </React.Fragment>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    );
}

export default (TermsAndConditionsContent);